import { MainColor } from '../../../palette';

export const getIconButtonThemeConfig = () => {
  return {
    states: {
      defaultState: {
        backgroundColor: 'navy80' as MainColor,
        svgBackgroundColor: 'white100' as MainColor,
        color: 'navy80' as MainColor,
      },
      hover: {
        backgroundColor: 'navy5' as MainColor,
        color: 'navy70' as MainColor,
      },
      active: {
        backgroundColor: 'navy10' as MainColor,
        color: 'navy60' as MainColor,
      },
      focusVisible: {
        backgroundColor: 'navy10' as MainColor,
        color: 'navy60' as MainColor,
      },
      focus: {
        color: 'navy80' as MainColor,
        outlineColor: 'navy40' as MainColor,
      },
    },
  };
};
